import { render, staticRenderFns } from "./manifest.vue?vue&type=template&id=1f3731ba&scoped=true"
import script from "./manifest.vue?vue&type=script&lang=js"
export * from "./manifest.vue?vue&type=script&lang=js"
import style0 from "./manifest.vue?vue&type=style&index=0&id=1f3731ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3731ba",
  null
  
)

export default component.exports